import { defineCollectionStore } from '@/utils/defineCollectionStore';

export const useTrailsStore = defineCollectionStore({
	id: 'trails',
	endpoint: '/api/trails',
	dataKey: 'data',
	mapKey: 'trailsMap',
	dataFallback: [],
	mapFallback: {},
	errorLabel: 'Fetch Trails Error: ',
	fetchName: 'fetchTrails',
	extraState: () => ({
		data: null,
		archivedData: null,
		trailsMap: null,
	}),
	archive: {
		toggleName: 'toggleArchivedTrails',
		archivedDataKey: 'archivedData',
		// No `archivedMapKey`: the old store shares a single `trailsMap` between the live and archived fetch.
		archivedFetchName: 'fetchArchivedTrails',
		archivedEndpoint: (year) => `/api/archive/${year}/trails`,
		getters: {
			trailsData: 'data',
		},
	},
});
